import React, { useContext, useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import Moment from 'react-moment';
import StatusModifier from '../../myorders/orders/statusmodifier/StatusModifier';
import axios from 'axios';
import { useAlert } from 'react-alert';
import AuthContext from '../../../authentication/AuthContext';

export default function BestwayTransactionHeader({ depotId, transactionId }) {
    const [transaction, setTransaction] = useState();
    const alert = useAlert();
    const cas = useContext(AuthContext);

    useEffect(() => {
        axios
            .get(
                window.CONFIG['ws.activoc-web-order-api.bestway.header.summary']
                    .replace('{depot}', depotId)
                    .replace('{id}', transactionId),
                {
                    headers: {
                        Authorization: cas,
                        'Content-Type': 'application/json'
                    }
                }
            )
            .then(response => {
                setTransaction(response.data);
            })
            .catch(e => {
                console.error(e);
                alert.error('ERROR: Unable to retrieve transaction summary');
            });
    }, []);

    return (
        <div className={'order-header-container'}>
            <h1>Depot Transaction: {transactionId}</h1>
            <Row className={'order-info'}>
                <Col sm={3}>
                    <p>
                        <strong>Supplier: </strong> Bestway
                    </p>
                    <p>
                        <strong>Supplier order no: </strong> {transactionId}
                    </p>
                    <p>
                        <strong>Created: </strong>{' '}
                        {transaction && (
                            <Moment format={'dddd DD/MM/YYYY HH:mm'}>{transaction?.createdTimestamp}</Moment>
                        )}
                    </p>
                </Col>
                <Col sm={3}>
                    <p>
                        <strong>Status: </strong>{' '}
                        {transaction && <StatusModifier orderHeader={transaction} />}
                    </p>
                    <p>
                        <strong>Originating system: </strong>N/A
                    </p>
                    <p>
                        <strong>Delivery day: </strong>N/A
                    </p>
                </Col>
                <Col sm={2} className={'totals'}>
                    <p>
                        <strong>Total lines: </strong> {transaction?.totalLines}
                    </p>
                    <p>
                        <strong>Total cases: </strong> {transaction?.totalCases}
                    </p>
                </Col>
                <Col sm={4} className={'totals'}>
                    <p>
                        <strong>Total cost: </strong>
                    </p>
                    <p className={'total-cost'}>
                        {transaction && (
                            <strong>
                                £{Math.floor(transaction.totalCost)}
                                <sup>{(transaction.totalCost % 1).toFixed(2).substring(1)}</sup>
                            </strong>
                        )}
                    </p>
                </Col>
            </Row>
        </div>
    );
}
